import { z } from 'zod'

/** Parsed GET query (optional fields; API applies defaults in the handler). */
export const helpDocsSearchQuerySchema = z.object({
  search: z.string().max(500).optional(),
  limit: z.coerce.number().int().min(1).max(25).optional(),
})

export type HelpDocsSearchQuery = z.infer<typeof helpDocsSearchQuerySchema>

export const helpDocHitSchema = z.object({
  id: z.string(),
  title: z.string(),
  url: z.string().url(),
  snippet: z.string().optional(),
})

export const helpDocsSearchResponseSchema = z.object({
  data: z.array(helpDocHitSchema),
})

export type HelpDocsSearchResponse = z.infer<
  typeof helpDocsSearchResponseSchema
>
export type HelpDocHit = z.infer<typeof helpDocHitSchema>
